import HttpClient from "./HttpClient";

export default class PackingType {
  constructor(packingType) {
    this.allow_different_orders = packingType.allow_different_orders;
    this.company_id = packingType.company_id;
    this.created_at = packingType.created_at;
    this.description = packingType.description;
    this.id = packingType.id;
    this.pallet_height = packingType.pallet_height;
    this.pallet_width = packingType.pallet_width;
    this.spacing_between = packingType.spacing_between;
    this.spacing_ends = packingType.spacing_ends;
    this.spacing_sides = packingType.spacing_sides;
    this.updated_at = packingType.updated_at;
    this.text = packingType.description; //required for v-select
    this.value = packingType.id; //required for v-select
    this.max_weight = packingType.max_weight;
    this.max_height = packingType.max_height;
    this.truck_height = packingType.truck_height;
    this.truck_length = packingType.truck_length;
    this.truck_width = packingType.truck_width;
    this.default_truck_spacing = packingType.default_truck_spacing;
  }

  static async loadPackingTypes(){
    const client = new HttpClient();
    const response = await client.instance.get("packing-types");
    let packingTypes = [];
    response.data.forEach(element => {
      packingTypes.push(new PackingType(element));
    });
    return packingTypes;
  }

  static async create(data){
    const client = new HttpClient();
    const response = await client.instance.post(`packing-types`, data);
    return response.data; 
  }

  async save(){
    const client = new HttpClient();
    const response = await client.instance.put(`packing-types/${this.id}`, this);
    return response.data; 
  }

  async delete(){
    const client = new HttpClient();
    const response = await client.instance.delete(`packing-types/${this.id}`, this);
    return response.data; 
  }
}
